import { List } from 'immutable'
import { selectVideoById } from '../../services/node/index'
import { getPmSectionTabs } from '../../services/pm-section/index'

export function selectTitle ({ pmSection, pmScreen, user }) {
  const language = user.getIn(['data', 'language', 0], 'en')
  const sectionId = pmScreen.getIn(['portal', language, 'data', 'sectionIds', 0], '')
  const tabs = getPmSectionTabs({ sectionId, pmSection })
  const firstTab = tabs.get(0)
  return firstTab ? firstTab.get('tabLabel', '') : ''
}

export function selectVideos (state) {
  const {
    pmSection, pmScreen, auth, user,
  } = state
  const language = user.getIn(['data', 'language', 0], 'en')
  const sectionId = pmScreen.getIn(['portal', language, 'data', 'sectionIds', 0], '')
  const tabs = getPmSectionTabs({ sectionId, pmSection })
  const firstTab = tabs.get(0)
  const items = firstTab ? firstTab.get('tabContent', List()) : List()

  return items.map((item, index) => {
    const id = item.get('contentId')
    const data = selectVideoById(state, {
      id, language, subPath: ['data'], defaultValue: null,
    })
    if (data && index === 0) {
      const isFree = !auth.get('jwt')
      return data.set('isFree', isFree)
    }
    return data
  })
}
